import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';

const Orders = {
  Helmet: lazy(() => import('./components/OrdersHelmet')),
  DigitalPositions: lazyNamed(() => import('./containers/DigitalPositions'), 'DigitalPositions'),
  PrintPositions: lazyNamed(() => import('./containers/PrintPositions'), 'PrintPositions'),
  ProgrammaticDeals: lazy(() => import('./containers/ProgrammaticDeals').then(({ ProgrammaticDeals }) => ({ default: ProgrammaticDeals }))),
  PositionHistory: {
    Component: lazy(() => import('./containers/PositionHistory')),
    Providers: lazy(() => import('./containers/PositionHistory/components/Providers')),
  },
  Forecast: lazyNamed(() => import('./containers/Forecast'), 'Forecast'),
  BroadcastPositions: lazyNamed(() => import('./containers/BroadcastPositions'), 'BroadcastPositions'),
  Booking: lazyNamed(() => import('./containers/Booking'), 'Booking'),
  Campaigns: {
    CampaignsList: lazyNamed(() => import('./containers/Campaigns/pages/CampaignsList'), 'CampaignsList'),
    Order: lazyNamed(() => import('./containers/Campaigns/pages/Order'), 'Order'),
  },
  PointOfSalePositions: lazyNamed(() => import('./containers/PointOfSalePositions'), 'PointOfSalePositions'),
};

export default Orders;
